var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edu-layout',{attrs:{"type":"table"}},[_c('veBaseBanjiBzr',{attrs:{"slot":"table","viewType":"his"},slot:"table"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }